// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export {};

throw new Error(
  'The index.js entry point has been removed. Please update your ESLint configuration to import one of the' +
    ' profile paths such as "@rushstack/eslint-config/profile/web-app" or "@rushstack/eslint-config/profile/node.' +
    '\n\nSee the documentation for details: https://www.npmjs.com/package/@rushstack/eslint-config'
);
